const getPowerSensorTypes = () => {
  return {
    "US": true,
    "EX": true,
  };
}

export default getPowerSensorTypes;
